// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  height: 100vh;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  position: relative;
  flex-wrap: wrap;
}

.container {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgb(0, 0, 0);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 100%;
  background-color: rgb( 0, 0, 0); 
  background-color: rgba( 0, 0, 0, 0.3); 
  color: white;
}

h1 {
  text-align: center;
  color: white;
  margin-bottom: 30px;
}

.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.tabs button {
  flex: 1 1;
  padding: 10px;
  border: none;
  background: #f0f0f0;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
  transition: all 0.3s;
}

.tabs button.active {
  background: #667eea;
  color: white;
}

form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

input {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
}

input:focus {
  outline: none;
  border-color: #667eea;
}

.error {
  background: #fee;
  color: #c33;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  text-align: center;
}

.user-info {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  margin: 20px 0;
}

.user-info p {
  margin: 10px 0;
  color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAA8C;EAC9C,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gFAAgF;EAChF,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-image: url(\"images/background.jpg\");\n  background-position: center;\n  background-size: cover;\n  height: 100vh;\n  width: 100%;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  position: relative;\n  flex-wrap: wrap;\n}\n\n.container {\n  background: white;\n  padding: 40px;\n  border-radius: 10px;\n  box-shadow: 0 10px 40px rgb(0, 0, 0);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 400px;\n  width: 100%;\n  background-color: rgb( 0, 0, 0); \n  background-color: rgba( 0, 0, 0, 0.3); \n  color: white;\n}\n\nh1 {\n  text-align: center;\n  color: white;\n  margin-bottom: 30px;\n}\n\n.tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.tabs button {\n  flex: 1;\n  padding: 10px;\n  border: none;\n  background: #f0f0f0;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 16px;\n  transition: all 0.3s;\n}\n\n.tabs button.active {\n  background: #667eea;\n  color: white;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\ninput {\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\ninput:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.error {\n  background: #fee;\n  color: #c33;\n  padding: 10px;\n  border-radius: 5px;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.user-info {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 5px;\n  margin: 20px 0;\n}\n\n.user-info p {\n  margin: 10px 0;\n  color: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
